module.exports = __webpack_public_path__ + "img/img18.f4d5a4b4.jpg";